import styled from 'styled-components'
import { theme } from '@notino/react-styleguide'
import { multiLineClamp, NotinoBodySmall, NotinoLabelLarge, NotinoLabelSmall400 } from '../../../styles/helpers'
import { BREAKPOINTS } from '../../../styles/constants'

export const HeaderWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	@media (min-width: ${BREAKPOINTS.lg}) {
		flex-direction: row;
		align-items: center;
		gap: 4px;
	}
`

export const HeaderContentTitle = styled.div`
	${NotinoLabelLarge};
	color: ${theme.color.text.inverse};
	${multiLineClamp(1)};
	@media (min-width: ${BREAKPOINTS.lg}) {
		${NotinoLabelSmall400};
		color: ${theme.color.text.primary};
	}
`

export const HeaderContentDescription = styled.div`
	${NotinoBodySmall};
	color: #e1e1e1;
	${multiLineClamp(1)};
	@media (min-width: ${BREAKPOINTS.lg}) {
		${NotinoLabelSmall400};
		color: ${theme.color.text.tertiary};
	}
`
